export default __webpack_public_path__ + "static/media/printing_queue_done.7f34df83.png";